<template>
	<div v-if="data">
		<p v-if="data.date" class="group-date">{{ itemDate }}</p>
		<div
			class="affair-list-item"
			v-else
			:class="{ marked: isMarked() }"
			@click.stop="editTask"
		>
			<div class="list-item-top">
				<b
					v-if="data.order && data.order.id"
					:class="{'completed': data.is_completed, 'isNotRelevant': data.isNotRelevant}"
					class="w-full"
				>{{ $t('order') }} № {{data.order.id}}</b>

				<div v-else class="description-wrapper w-full">
					<b>{{ getTime(data.date_time) }}</b>
					<p
						:class="{'completed': data.is_completed, 'isNotRelevant': data.isNotRelevant}"
						class="description-wrapper__text"
					>{{ data.description }}</p>
				</div>
				<div class="controls-wrapper" @click.stop>
					<feather-icon
						v-if="$store.state.auth.role !== 'manager' && !data.is_by_admin"
						@click.stop="assignToManager"
						icon="UserPlusIcon"
						size="'30'"
						svgClasses="h-4 w-4" class="ml-1"
					/>
					<vs-checkbox
						@click.stop
						@input="dlgCompletedTask = true"
						v-model="data.is_completed"
						class="inline-flex"
					></vs-checkbox>
					<div class="list-item-top__right">
						<feather-icon
							v-if="$store.state.auth.role === 'admin'"
							@click.stop="dlgDeleteTask = true"

							icon="Trash2Icon"
							size="'30'"
							svgClasses="h-4 w-4"
							class="ml-1"
						/>
						<feather-icon
							v-if="$store.state.auth.role === 'manager'"
							@click.stop="dlgNotRelevantTask = true"
							icon="Trash2Icon"
							size="'30'"
							svgClasses="h-4 w-4"
							class="ml-1"
						/>
					</div>
				</div>
			</div>
			<div class="list-item-bottom">
				<div
					v-if="data.order && data.order.id"
					:class="{'completed': data.is_completed, 'isNotRelevant': data.isNotRelevant}"
					class="row_manager_name_task w-full"
				><b>{{ $t('manager') }}</b>: {{data.fioUser}}</div>
			</div>
			<div class="list-item-bottom">
				<div v-if="data.order && data.order.id" class="description-wrapper">
					<b>{{ getTime(data.date_time) }}</b>
					<p
						:class="{'completed': data.is_completed, 'isNotRelevant': data.isNotRelevant}"
						class="description-wrapper__text"
					>{{ data.description }}</p>
				</div>
				<p v-if="data.is_by_admin && !$store.getters['isAdmin']" class="provided-by-admin">{{ $t('setByAdmin') }}</p>
			</div>
		</div>
		<ModalDeleteTask
			:active.sync="dlgDeleteTask"
			@accept="deleteTask"
		/>
		<ModalNotRelevantTask
			:active.sync="dlgNotRelevantTask"
			@accept="notRelevantTask"
		/>
		<ModalCompletedTask
			:active.sync="dlgCompletedTask"
			@accept="changeTaskState(true)"
			@cancel="changeTaskState(false)"
		/>
	</div>
</template>

<script setup>
  import { ref } from 'vue';

  const dialog = ref(false);
</script>

<script>
import moment from 'moment';
import date from "@/assets/configs/date.js";
import ModalDeleteTask from "@/components/dialogs/ModalDeleteTask";
import ModalNotRelevantTask from "@/components/dialogs/ModalNotRelevantTask";
import ModalCompletedTask from "@/components/dialogs/ModalCompletedTask";
import databaseManager from "@/mixins/databaseManager";
import notifier from "@/mixins/notifier";

export default {
	name: 'AffairListItem',
	mixins: [databaseManager, notifier],
	props: {
		data: {
			type: Object,
		}
	},
	data() {
		return {
			dlgDeleteTask: false,
			dlgNotRelevantTask: false,
			dlgCompletedTask: false,
		};
	},
	components: {
		ModalDeleteTask,
		ModalNotRelevantTask,
		ModalCompletedTask,
	},
	computed: {
		itemDate() {
			const dateMoment = moment(this.data.date);
			const weekDay = this.$t(date.days[dateMoment.day()]);
			const day = dateMoment.format("DD")
			const month = this.$t(date.months[dateMoment.month()] + "Genitive");
			const year = dateMoment.format("YYYY");
			return `${weekDay}, ${day} ${month} ${year}`;
		}
	},
	methods: {
		getTime(datetime) {
			const [date, time] = datetime.split(" ");
			const [h, m] = time.split(":");
			return `${h}:${m}`;
		},
		async changeTaskState (e) {
			setTimeout(() => {
				if (e) {
					this.$store.dispatch('calendar/setTaskCompleted', this.data);
					this.notifySuccess(this.$t("completedTaskNotification"));
				} else {
					this.data.is_completed = 0;
					// this.$store.dispatch('calendar/reopenTask', this.data);
				}
			}, 300);
		},
		deleteTask () {
			try {
				this.$store.dispatch('calendar/deleteTask', this.data);	

				this.notifySuccess(this.$t("deleteTaskNotification"));
			} catch (e) {
				this.notifyError(this.$t('errorNotification'));
			}
		},
		async notRelevantTask () {
			try {
				await this.dbNotRelevantTask(this.data.id);

				this.$store.dispatch('calendar/notRelevantTaskTask', this.data);	

				this.notifySuccess(this.$t("switchStatusTaskNotRelevantNotification"));
			} catch (e) {
				this.notifyError(this.$t('errorNotification'));
			}
		},
		assignToManager () {
			this.$emit('assignToManager', this.data)
		},
		editTask(){
			this.$emit('editTask', this.data)
		},
		isMarked() {
			const taskDate = this.data.date_time;
			const currentDate = moment(new Date()).format("YYYY-MM-DD");
			return currentDate > taskDate;
		},
	}
}
</script>

<style lang="scss">
.group-date {
	padding: 1rem;
}
.row_manager_name_task {
	margin: auto;
	display: flex;
}
.affair-list-item {
	background-color: red;
	padding: 1rem;
	width: 100%;
	display: flex;
	cursor: pointer;
	flex-direction: column;
	background-color: #f1f1f166;
	border-top: 1px solid #ddd;

	&.marked {
		background-color: #F4A9A9;
	}

	.completed {
		text-decoration: line-through;
	}

	.isNotRelevant {
		text-decoration: line-through;
	}

	&:last-of-type{
		border-bottom: 1px solid #ddd;
	}

	.list-item-top {
		display: flex;
		flex-grow: 1;

		b {
			flex-grow: 1;
		}

		.controls-wrapper {
			display: flex;
			align-items: center;
			margin-bottom: 8px;
		}

		&__right {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 20px;
			height: 20px;
		}
	}

	.list-item-bottom {
		display: flex;

		.description-wrapper {
			display: flex;
			flex-grow: 1;

			&__text {
				word-break: break-word;
			}

			b {
				margin-right: 1rem;
			}

		}

		.provided-by-admin {
			font-size: 10px;
			width: 15%;
			margin-right: 10px;
		}
	}

	.vs-checkbox {
		background-color: white;
		border-color: #6f6f6f !important;
	}
}
</style>
